import React, { useState, useEffect } from "react";
import Loader from "./components/Loader";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import HistoryValuesSection from "./components/HistoryValuesSection";
import ProjectsSection from "./components/ProjectsSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";

const LandingPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isLoading ? "hidden" : "unset";
  }, [isLoading]);

  const handleLoadComplete = () => {
    setIsLoading(false);
    setTimeout(() => setShowContent(true), 100);
  };

  return (
    <div className="App">
      {isLoading && <Loader onLoadComplete={handleLoadComplete} />}
      <div className={`transition-opacity duration-700 ${showContent ? "opacity-100" : "opacity-0"}`}>
        <Header />
        <HeroSection />
        <ServicesSection />
        <HistoryValuesSection />
        <ProjectsSection />
        <AboutSection />
        <ContactSection />
        <Footer />
      <Toaster />
      </div>
    </div>
  );
};

export default LandingPage;
